import { AxiosResponse } from "axios";
import { PrintHistoryFooter } from "../types/printHistoryFooter";
import { aplClient } from "./apiClient";

const getPrintHistoryFooters = (siteId: number, hours: number = 24): Promise<AxiosResponse<PrintHistoryFooter[], any>> =>
    aplClient().get(`printHistoryFooters?siteId=${siteId}&lineId=0&hoursBack=24`);

export { getPrintHistoryFooters };
